﻿import "jquery-ui-dist/jquery-ui.js";
import "jquery-ui-dist/jquery-ui.css";

export class DatePicker {
    constructor(elem) {
        let isFrame, parentId;
        const $picker = $(elem);
        isFrame = window.frameElement;
        if (isFrame) parentId = window.frameElement.id;

        $picker.datepicker({
            dateFormat: "mm/dd/yy",
            beforeShow: (date) => {
                this.beforeShow($picker, parentId);
            },
            onSelect: () => {
                this.selectSuccess($picker);
            },
            onClose: () => {
                this.onClose(parentId);
            },
            showAnim: "fadeIn",
            showOptions: {
                direction: "down"
            }
        });
    }

    beforeShow($picker, parentId) {
        // Run any success methods here before user provided callback

        const $validationMsg = $picker.closest('.date-wrapper').next('span[data-valmsg-for]');
        const hasError = $picker.hasClass('input-validation-error');
        /*
        if (parentId) {
            setTimeout(() => {
                this.resizeiFrameforDate(parentId);
            }, 100);
        }
        */
        if (!hasError) {
            $validationMsg.hide();
        }
        else {
            $validationMsg.show();
            if (parentId) {
                this.resizeiFrameforDate(parentId);
            }
        }

        this.onBeforeShow();
    }
    // Access to post share success method
    onBeforeShow() { }

    selectSuccess($picker) {
        // Run any success methods here before user provided callback
        const $validationMsg = $picker.closest('.date-wrapper').next('span[data-valmsg-for]');
        $picker.valid();
        $validationMsg.show();
 
        this.onSelectSuccess();
    }
    // Access to post share success method
    onSelectSuccess() { }


    onClose(parentId) {
        // Run any success methods here before user provided callback

        if (parentId) {
            this.resizeiFrameforDate(parentId, true);
        }

        this.onCloseSuccess();
    }
    // Access to post share success method
    onCloseSuccess() { }


    resizeiFrameforDate(parentId, closed) {
        closed = closed ? closed : false;
        var newHeight;
        var calendarHeight = $('.ui-datepicker-calendar').outerHeight(false);

        var iframeRef = parent.document.getElementById(parentId);
        if (closed) newHeight = iframeRef.contentWindow.document.body.scrollHeight;
        else newHeight = iframeRef.contentWindow.document.body.scrollHeight + calendarHeight;
        iframeRef.height = newHeight + "px";
    }
}